import React from "react";
import CapsuleImageVertical from "../CapsuleImageVertical/CapsuleImageVertical";
import TemporaryLifeImage from "../../Assets/Images/temporary-life.png";
import { Container } from "reactstrap";
import SectionTwoImageMobile from "../../Assets/Images/temporary-life-mobile-img.png";
import wardsImage from "../../Assets/Images/wards.png";
import PlusWhiteIcon from "../../Assets/Images/plus-white.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "../../Hooks/useTranslation";

const TermLife = ({ isScrollable, sectionActive }) => {
  const translations = useTranslation(); // Get translations dynamically
  return (
    <>
      <div
        className={`${!isScrollable ? "item" : ""} ${
          sectionActive ? "active-container" : ""
        }`}
      >
        <div className="w-full flex  gap-8 lg:flex-row flex-col-reverse justify-between lg:items-center">
          <div className="mt-2 mb-4 lg:pl-0 pl-4 our-prod-tab-content  max-w-[408px]">
            {/* <h3
              className="lg:text-[24px] text-[16px]  font-semibold mb-2 lg:leading-[28px] leading-[20px]"
              id="TermLife"
            >
              {translations.termLifeHeading}
            </h3> */}
            <p className=" text-[14px] mb-3 extra-para-vs">
             <span className="font-bold">{translations.termLifeDescriptionBold}</span> {translations.termLifeDescription}
            </p>
            <div className="flex gap-3 lg:mt-9 mt-4">
              <Link
                to="/term-life-insurance"
                className="
                bg-[#0D4248] hover:bg-[#0D4248] hover:text-[#ffffff]
                text-white font-bold rounded-full text-sm px-5 text-center gotofaqbtn flex extra-btn-font"
              >
                <img src={PlusWhiteIcon} className="mr-2" alt="Plus Icon" />{" "}
                {translations.productMoreButton}
              </Link>
              <Link
                to="/compare-plans"
                className="flex text-[#0D4248] font-bold border border-[#0D4248] border-solid rounded-full text-sm px-5 text-center extra-btn-font  gotofaqbtn hover:bg-[#6750a4] hover:bg-opacity-[0.08]"
              >
                {translations.productCompareButton}
              </Link>
            </div>
          </div>
          <div className="product-right-img">
            <div className="hidden lg:block">
              <img src={TemporaryLifeImage} alt="Temporary Life" />
            </div>
            <div className="mt-4 -mr-4 lg:hidden flex justify-center">
              <img
                src={SectionTwoImageMobile}
                alt="section-two-image-mobile"
                className="w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermLife;
